<template>
<el-drawer :title="drawer.title" :visible.sync="drawer.visible" size="80%" :append-to-body="true" :center="true" :wrapperClosable="false" :before-close="closeDrawer">
    <div class="hs-container hs-process" id="printTest">
        <div v-if="type=='settle'">
            <el-button type="primary" @click="excelFile">导出</el-button>
            <div v-if="addonsDatafour.length > 0">
                <el-divider content-position="left">
                    <el-tag type="success">四大金刚</el-tag>
                </el-divider>
                <el-table :data="addonsDatafour" border class="table_list">
                    <el-table-column prop="supplier.title" label="供应商" show-overflow-tooltip></el-table-column>
                    <el-table-column label="结算状态" align="center" width="160" :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <el-link v-if="scope.row.settle==0">待结算</el-link>
                            <el-link type="primary" v-if="scope.row.settle==1">结算中</el-link>
                            <el-link type="success" v-if="scope.row.settle==2">结算通过</el-link>
                            <el-link type="danger" v-if="scope.row.settle==3">结算驳回</el-link>
                        </template>
                    </el-table-column>
                    <el-table-column prop="category.title" label="类型"></el-table-column>
                    <el-table-column prop="product.title" label="产品" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="product.price" label="价格" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="count" label="数量" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="product_price" label="预设小计"></el-table-column>
                    <el-table-column prop="other_fee" label="其他金额" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="total" label="实际费用"></el-table-column>
                </el-table>
            </div>
            <div v-if="addonsDatapurchase.length > 0">
                <el-divider content-position="left">
                    <el-tag type="success">采购</el-tag>
                </el-divider>
                <el-table :data="addonsDatapurchase" border class="table_list">
                    <el-table-column label="供应商">
                        <template slot-scope="scope" v-if="scope.row.supplier">
                            <span class="text-color1"> {{scope.row.supplier.title}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="结算状态" align="center" width="160" :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <el-link v-if="scope.row.settle==0">待结算</el-link>
                            <el-link type="primary" v-if="scope.row.settle==1">结算中</el-link>
                            <el-link type="success" v-if="scope.row.settle==2">结算通过</el-link>
                            <el-link type="danger" v-if="scope.row.settle==3">结算驳回</el-link>
                        </template>
                    </el-table-column>
                    <el-table-column prop="title" label="物品名称"></el-table-column>
                    <el-table-column prop="spec" label="规格"></el-table-column>
                    <el-table-column prop="amount" label="数量"></el-table-column>
                    <el-table-column prop="price" label="单价"></el-table-column>
                    <el-table-column prop="total" label="总价"></el-table-column>
                    <el-table-column prop="real_total" label="实际总价"></el-table-column>

                    <el-table-column label="物料">
                        <template slot-scope="scope" v-if="scope.row.product">
                            <span class="text-color1"> {{scope.row.product.title}}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div v-if="addonsDataProject.length > 0">
                <el-divider content-position="left">
                    <el-tag type="success">工程</el-tag>
                </el-divider>
                <el-table :data="addonsDataProject" border class="table_list">
                    <el-table-column prop="create_time" label="添加时间" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="supplier.title" label="供应商" show-overflow-tooltip></el-table-column>
                    <el-table-column label="结算状态" align="center" width="160" :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <el-link v-if="scope.row.settle==0">待结算</el-link>
                            <el-link type="primary" v-if="scope.row.settle==1">结算中</el-link>
                            <el-link type="success" v-if="scope.row.settle==2">结算通过</el-link>
                            <el-link type="danger" v-if="scope.row.settle==3">结算驳回</el-link>
                        </template>
                    </el-table-column>
                    <el-table-column prop="product.title" label="产品" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="product.price" label="产品单价" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="count" label="数量" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="price" label="自定义小计" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="product_price" label="产品小计" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="total" label="实际费用" show-overflow-tooltip></el-table-column>
                </el-table>
            </div>
            <div v-if="addonsDataDesgin.length > 0">
                <el-divider content-position="left">
                    <el-tag type="success">设计出版物料</el-tag>
                </el-divider>
                <el-table :data="addonsDataDesgin" border class="table_list">
                    <el-table-column prop="create_time" label="添加时间" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="supplier.title" label="供应商" show-overflow-tooltip></el-table-column>
                    <el-table-column label="结算状态" align="center" width="160" :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <el-link v-if="scope.row.settle==0">待结算</el-link>
                            <el-link v-if="scope.row.settle==1">结算中</el-link>
                            <el-link v-if="scope.row.settle==2">结算通过</el-link>
                            <el-link v-if="scope.row.settle==3">结算驳回</el-link>
                        </template>
                    </el-table-column>
                    <el-table-column prop="product.title" label="产品" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="product.price" label="产品单价" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="count" label="数量" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="price" label="自定义小计" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="product_price" label="产品小计" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="total" label="实际费用" show-overflow-tooltip></el-table-column>
                </el-table>
            </div>

            <div v-if="addonsDataDemand.length > 0">
                <el-divider content-position="left">
                    <el-tag type="success">需求单</el-tag>
                </el-divider>
                <el-table :data="addonsDataDemand" border class="table_list">
                    <el-table-column prop="create_time" label="添加时间" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="supplier.title" label="供应商" show-overflow-tooltip></el-table-column>
                    <el-table-column label="结算状态" align="center" width="160" :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <el-link v-if="scope.row.settle==0">待结算</el-link>
                            <el-link v-if="scope.row.settle==1">结算中</el-link>
                            <el-link v-if="scope.row.settle==2">结算通过</el-link>
                            <el-link v-if="scope.row.settle==3">结算驳回</el-link>
                        </template>
                    </el-table-column>
                    <el-table-column prop="product.title" label="产品" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="product.price" label="产品单价" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="count" label="数量" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="price" label="自定义小计" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="product_price" label="产品小计" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="total" label="实际费用" show-overflow-tooltip></el-table-column>
                </el-table>
            </div>
            <div v-if="addonsDataFlower.length > 0">
                <el-divider content-position="left">
                    <el-tag type="success">花艺单</el-tag>
                </el-divider>
                <el-table :data="addonsDataFlower" border class="table_list">
                    <el-table-column prop="supplier.title" label="供应商" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="total" label="实际费用" show-overflow-tooltip></el-table-column>
                </el-table>
            </div>
        </div>
        <div v-else>
            <el-button type="primary" @click="exportExcel" style="margin-bottom:10px">导出</el-button>
            <div v-if="type=='purchase'">
                <el-table :data="addonsData" border class="table_list" ref="multipleTable" :show-summary="true" :summary-method="getSummaries" id="addonsData">
                    <el-table-column label="供应商">
                        <template slot-scope="scope" v-if="scope.row.supplier">
                            <span class="text-color1"> {{scope.row.supplier.title}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="结算状态" align="center" width="160" :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <el-link v-if="scope.row.settle==0">待结算</el-link>
                            <el-link type="primary" v-if="scope.row.settle==1">结算中</el-link>
                            <el-link type="success" v-if="scope.row.settle==2">结算通过</el-link>
                            <el-link type="danger" v-if="scope.row.settle==3">结算驳回</el-link>
                        </template>
                    </el-table-column>
                    <el-table-column prop="title" label="物品名称"></el-table-column>
                    <el-table-column prop="spec" label="规格"></el-table-column>
                    <el-table-column prop="amount" label="数量"></el-table-column>
                    <el-table-column prop="price" label="单价"></el-table-column>
                    <el-table-column prop="total" label="总价"></el-table-column>
                    <el-table-column prop="real_total" label="实际总价"></el-table-column>

                    <el-table-column label="物料">
                        <template slot-scope="scope" v-if="scope.row.product">
                            <span class="text-color1"> {{scope.row.product.title}}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div v-else-if="type=='four'">
                <el-table :data="addonsData" :show-summary="true" :summary-method="getSummaries" id="addonsData">
                    <el-table-column prop="supplier.title" label="供应商" show-overflow-tooltip></el-table-column>
                    <el-table-column label="结算状态" align="center" width="160" :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <el-link v-if="scope.row.settle==0">待结算</el-link>
                            <el-link type="primary" v-if="scope.row.settle==1">结算中</el-link>
                            <el-link type="success" v-if="scope.row.settle==2">结算通过</el-link>
                            <el-link type="danger" v-if="scope.row.settle==3">结算驳回</el-link>
                        </template>
                    </el-table-column>
                    <el-table-column prop="category.title" label="类型"></el-table-column>
                    <el-table-column prop="product.title" label="产品" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="product.price" label="价格" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="count" label="数量" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="product_price" label="预设小计"></el-table-column>
                    <el-table-column prop="total" label="实际费用"></el-table-column>
                </el-table>
            </div>
            <div v-else-if="type=='flower'" border class="table_list" ref="multipleTable1" :show-summary="true" :summary-method="getSummaries" id="addonsData">
                <el-table :data="addonsDataFlower" border class="table_list">
                    <el-table-column prop="supplier.title" label="供应商" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="total" label="实际费用" show-overflow-tooltip></el-table-column>
                </el-table>
            </div>
            <div v-else>
                <el-table :data="addonsData" border class="table_list" ref="multipleTable1" :show-summary="true" :summary-method="getSummaries" id="addonsData">
                    <el-table-column prop="create_time" label="添加时间" show-overflow-tooltip></el-table-column>
                    <el-table-column label="结算状态" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-link v-if="scope.row.settle==0">待结算</el-link>
                            <el-link type="primary" v-else-if="scope.row.settle==1">结算中</el-link>
                            <el-link type="success" v-else-if="scope.row.settle==2">结算通过</el-link>
                            <el-link type="danger" v-else>结算驳回</el-link>
                        </template>
                    </el-table-column>
                    <el-table-column prop="supplier.title" label="供应商" show-overflow-tooltip></el-table-column>

                    <el-table-column prop="product.title" label="产品" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="product.price" label="产品单价" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="count" label="数量" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="price" label="自定义小计" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="product_price" label="产品小计" show-overflow-tooltip></el-table-column>

                    <el-table-column prop="total" label="实际费用" show-overflow-tooltip></el-table-column>
                </el-table>

            </div>

        </div>
    </div>

    <el-divider content-position="left"> 总计：{{totals}}</el-divider>
</el-drawer>
</template>

<script>
import fileSaver from 'file-saver';
import xlsx from 'xlsx';
import {
    showDrawerPass,
} from '@/utils/common.js';
import former from '@/utils/former.js';
import weddingUtils from '@/utils/wedding.js';
export default {
    components: {},
    props: {
        parent: {}
    },
    data() {
        return {
            sumFields: ['product_price', 'total', 'price', 'real_total'],
            drawer: {
                title: '',
                visible: false
            },
            detailsData: {
                content: []
            },
            options: {},
            type: "",
            totals: {},
            confirm: {},
            confirmStep: [],
            row: {},
            activeNames: ['0'],
            addonsData: [],
            totals: "",
            addonsDatafour: [],
            addonsDatapurchase: [],
            addonsDataProject: [],
            addonsDataDesgin: [],
            addonsDataDemand: [],
            addonsDataFlower: [],
            order_id: ""

        }
    },
    beforeCreate() {
        this.showDrawerPass = showDrawerPass;
        this.former = former;
        this.getRuleTag = weddingUtils.getRuleTag;
    },
    updated() {

    },
    methods: {
        showDrawer(row, type) {
            let _this = this;
            _this.drawer.visible = true;
        },
        //总计
        showDrawersettle(row, type) {
            let _this = this;
            _this.type = type;
            _this.order_id = row.id;
            _this.drawer.title = '查看结算明细';
            _this.totals = row.settle_total;
            _this.drawer.visible = true;
            _this.addonsDatapurchase = [],
                _this.addonsDataProject = [],
                _this.addonsDataDesgin = [],
                _this.addonsDataDemand = [],
                _this.addonsDatafour = [],
                _this.addonsDataFlower = [],
                _this.getTableDataProject(row.id);
            _this.getTableDataDesgin(row.id)
            _this.getTableDataDemand(row.id);
            _this.getTableDatapurchase(row.id);
            _this.getTableDataFour(row.id),
                _this.getTableDataFlower(row.id)

        },
        excelFile() {
            let _this = this;
            let url = '/api/statistics.supplier/exportOrderBom';
            let options = {};
            options.order_id = _this.order_id,
                this.$post(url, options).then(res => {
                    if (res.code == '200') {
                        let link = document.createElement('a');
                        link.href = res.data.url;
                        link.click();

                    }
                })

        },
        getTableDataFour(orderId) {
            let _this = this;
            let url = '/api/statistics.supplier/getFourBom';
            let options = {
                order_id: orderId,
                type: "four"
            }
            this.$post(url, options).then(function (response) {
                let result = response.data;
                _this.addonsDatafour = result.list;

            });
        },
        getTableDataFlower(orderId) {
            let _this = this;
            let url = '/api/statistics.supplier/getFlowerFeeBom';
            let options = {
                order_id: orderId,
            }
            this.$post(url, options).then(function (response) {
                let result = response.data;
                _this.addonsDataFlower = result.list;
            

            });
        },
        getTableDataProject(orderId) {
            let _this = this;
            let url = '/api/statistics.supplier/getDemandBom';
            let options = {
                order_id: orderId,
                type: "project"
            }
            this.$post(url, options).then(function (response) {
                let result = response.data;
                _this.addonsDataProject = result.list;

            });
        },
        getTableDataDesgin(orderId) {
            let _this = this;
            let url = '/api/statistics.supplier/getDemandBom';
            let options = {
                order_id: orderId,
                type: "design"
            }
            this.$post(url, options).then(function (response) {
                let result = response.data;
                _this.addonsDataDesgin = result.list;

            });
        },
        getTableDataDemand(orderId) {
            let _this = this;
            let url = '/api/statistics.supplier/getDemandBom';
            let options = {
                order_id: orderId,
                type: "demand"
            }
            this.$post(url, options).then(function (response) {
                let result = response.data;
                _this.addonsDataDemand = result.list;

            });
        },
        getTableDatapurchase(orderId) {
            let _this = this;
            let url = '/api/statistics.supplier/getDemandBom';
            let options = {
                order_id: orderId,
                type: "purchase"
            }
            this.$post(url, options).then(function (response) {
                let result = response.data;
                _this.addonsDatapurchase = result.list;

            });
        },
        showDrawerRow(row, type) {
            let _this = this;
            _this.addonsData = [];
            _this.type = type;
            if (type == 'four') {
                _this.drawer.title = '查看四大金刚明细';
                _this.totals = row.four
            }
            if (type == 'demand') {
                _this.drawer.title = '查看需求单明细';
                _this.totals = row.demand
            }
            if (type == 'project') {
                _this.drawer.title = '查看工程单明细';
                _this.totals = row.project
            }
            if (type == 'design') {
                _this.drawer.title = '查看出版物料明细';
                _this.totals = row.design

            }
            if (type == 'purchase') {
                _this.drawer.title = '查看采购物料明细';
                _this.totals = row.purchase
            }
            if (type == 'flower') {
                _this.drawer.title = '查看花艺单明细';
                _this.totals = row.flower_fee
            }

            _this.drawer.visible = true;
            let query = {
                orderId: row.id,
                type: type
            }
            if (type == 'four') {
                _this.getTableFour(query)
            } else if (type == 'flower') {
                _this.getTableDataFlower(row.id)
            } else {
                _this.getTableData(query);
            }
            this.$forceUpdate();
        },
        getTableData(query) {
            let _this = this;
            let url = '/api/statistics.supplier/getDemandBom';
            let options = {
                order_id: query.orderId,
                type: query.type
            }
            this.$post(url, options).then(function (response) {
                let result = response.data;
                _this.addonsData = result.list;

            });
        },
        getTableFour(query) {
            let _this = this;
            let url = '/api/statistics.supplier/getFourBom';
            let options = {
                order_id: query.orderId,
                type: query.type
            }
            this.$post(url, options).then(function (response) {
                let result = response.data;
                _this.addonsData = result.list;

            });
        },
        exportExcel() {
            /* 从表生成工作簿对象 */
            var wb = xlsx.utils.table_to_book(document.querySelector('#addonsData'));
            /* 获取二进制字符串作为输出 */
            var wbout = xlsx.write(wb, {
                bookType: 'xlsx',
                bookSST: true,
                type: 'array'
            });
            try {
                fileSaver.saveAs(
                    //Blob 对象表示一个不可变、原始数据的类文件对象。
                    //Blob 表示的不一定是JavaScript原生格式的数据。
                    //File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
                    //返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
                    new Blob([wbout], {
                        type: 'application/octet-stream'
                    }),
                    //设置导出文件名称
                    'sheetjs.xlsx'
                );
            } catch (e) {}
            return wbout;
        },
        closeDrawer() {
            this.drawer.visible = false;
        },
        getSummaries(param) {
            const {
                columns,
                data
            } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '总价';
                    return;
                }

                if (this.sumFields.indexOf(column.property) < 0) {
                    sums[index] = '';
                    return;
                }

                const values = data.map(item => Number(item[column.property]));
                if (!values.every(value => isNaN(value))) {
                    let sum = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);

                    sums[index] = sum.toFixed(2);
                } else {
                    sums[index] = '';
                }
            });

            return sums;
        }
    }
}
</script>

<style lang="less" scoped>
@import url('@/assets/css/common.less');

.table_list {
    margin-bottom: 20px;
}

.hs-process {
    height: calc(100vh - 150px);
    overflow: auto;
}

.totals_box {
    margin-left: 20px;
}

.attr-date,
.attr-select,
.attr-input,
.attr-remark {
    margin-right: 8px;
}

.attr-input,
.attr-select,
.attr-remark {
    width: 220px;
}

/************ 分割线 **************/
.box {
    display: flex;
    position: relative;
    height: 100vh;
    overflow: hidden;
    margin-top: 50px;

    .box-center {
        flex: 1;
        height: 100vh;
        overflow: auto;
        padding-bottom: 100px;
    }

    .box-comment {
        flex: 0 20%;
        height: 100vh;
        overflow: auto;
        padding: 12px;
        border-left: 1px solid #dedede;
    }
}

.fixed-btns {
    position: fixed;
    top: 55px;
    left: 0;
    z-index: 2000;
    height: 55px;
    line-height: 55px;
    width: 100%;
    text-align: right;
    padding-right: 24px;
    background: #f6f7fb;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    height: 55px;
    width: 100%;
    text-align: right;
    padding-right: 24px;
    background: #f6f7fb;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    padding: 10px;
    line-height: 35px;
}

.selected-list {
    padding-left: 12px;
}

.selected-item {
    position: relative;
    cursor: pointer;

    .tree-title {
        padding: 8px;
        font-size: 14px;
        font-weight: 600;
    }

    .category-item {
        display: flex;
        border-top: 1px solid #dedede;

        .category-title {
            display: flex;
            width: 5rem;
            padding: 8px;
            align-items: center;
        }

        .category-rules {
            flex: 1;
            border-left: 1px solid #dedede;

            .category-item-form {
                padding: 8px;
                display: flex;

                .attr-date,
                .attr-select,
                .attr-textarea {
                    margin-right: 5px;
                    max-width: 120px;
                }

                .attr-input {
                    margin-right: 5px;
                    max-width: 120px;
                    min-width: 80px;
                }

                .attr-count {
                    margin-right: 5px;
                    width: 7rem;
                }

                .attr-remark {
                    margin-right: 5px;
                    flex: 1;
                }
            }
        }
    }

    .category-item:last-child {
        border-bottom: 1px solid #dedede;
    }

}

.selected-item:last-child {
    border-bottom: none;
}

/*** --------------------------------------- 分界线 ------------------------ ***/
.form-header {
    display: flex;
    padding: 12px;
    border-bottom: 1px solid #dedede;

    .form-submit {
        flex: 1;
        text-align: right;
    }
}

.main-demand {
    display: flex;

    .form-demand {
        flex: 1;
        padding-bottom: 20px;
    }

    .more-demand {
        flex: 0 25%;
        padding: 12px;
        border-left: 1px solid #dedede;
    }
}

.hs-table-pro {
    .hs-table-row {
        display: flex;
        border-top: .5px solid #f6f7fb;

        .hs-table-col {
            flex: 1;
            padding: 5px 8px;
            border-right: .5px solid #f6f7fb;
        }

        .hs-table-col.w120 {
            flex: 0 120px;
        }
    }

    .hs-table-row.hs-table-header {
        background: #f6f7fb;
        border-top: none;
    }
}

.selected-item {
    position: relative;
    cursor: pointer;

    .tree-title {
        padding: 8px;
        font-size: 14px;
        font-weight: 600;
    }

    .category-item {
        display: flex;
        border-top: 1px solid #dedede;

        .category-title {
            display: flex;
            width: 5rem;
            padding: 8px;
            align-items: center;
        }

        .category-rules {
            flex: 1;
            border-left: 1px solid #dedede;

            .category-item-form {
                padding: 8px;
                display: flex;

                .attr-date,
                .attr-select,
                .attr-textarea {
                    margin-right: 5px;
                    max-width: 120px;
                }

                .attr-input {
                    margin-right: 5px;
                    max-width: 120px;
                    min-width: 80px;
                }

                .attr-count {
                    margin-right: 5px;
                    width: 7rem;
                }

                .attr-remark {
                    margin-right: 5px;
                    flex: 1;
                }
            }
        }
    }

    .category-item:last-child {
        border-bottom: 1px solid #dedede;
    }

}

.selected-item:last-child {
    border-bottom: none;
}
</style>
